export const storeLinks = {
  apple: 'https://apps.apple.com/app/on-piste/id1597319695',
  google: 'https://play.google.com/store/apps/details?id=com.rossignol.onpiste',
};
